let toastifyStylesPromise: Promise<unknown> | null = null;

export const loadToastifyStyles = (): Promise<unknown> => {
  if (toastifyStylesPromise !== null) {
    return toastifyStylesPromise;
  }

  toastifyStylesPromise = import('react-toastify/dist/ReactToastify.css');

  return toastifyStylesPromise;
};
